module.exports = __webpack_public_path__ + "static/media/mapcontrols.43ca1fb0.jpg";